

















































import { Component, Vue } from "vue-property-decorator";
import CustomTable from "@/components/table.vue";
import NoticeApi from "@/api/admin/notice";
import { NoticeModel, PaginationModel } from "@/api/types";

@Component({
  components: {
    CustomTable,
  },
})
export default class Notice extends Vue {
  data: NoticeModel[] = [];
  pagination: PaginationModel & { total?: number; status?: number } = {
    current: 1,
    pageSize: 10,
    keyword: "",
    keywordType: "title",
    status: 0,
    total: 0,
  };
  visible = false;
  modalLoading = false;
  editMode = false;

  datum: NoticeModel = {
    title: "",
    content: "",
  };

  columns = [
    {
      width: 200,
      title: "id",
      dataIndex: "id",
    },
    {
      title: "title",
      dataIndex: "title",
    },
    {
      width: 200,
      align: "right",
      title: "작성일",
      dataIndex: "createdTime",
      scopedSlots: { customRender: "createdTime" },
    },
    {
      width: 200,
      align: "right",
      title: "동작",
      scopedSlots: { customRender: "action" },
    },
  ];

  moveOn(page: any) {
    this.pagination = page;
    this.load();
  }

  search() {
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  }

  reset() {
    this.pagination = {
      ...this.pagination,
      current: 1,
      keyword: "",
    };
    this.load();
  }

  showModal() {
    this.editMode = false;
    this.visible = true;
  }

  rowClick(record: NoticeModel) {
    this.editMode = true;
    this.visible = true;
    this.datum = {
      ...record,
    };
  }

  async remove(record: NoticeModel) {
    await NoticeApi.delete(record.id!);
    this.load();
  }

  async toggle(record: NoticeModel) {
    const notice: NoticeModel = {
      id: record.id,
      status: record.status,
    };
    await NoticeApi.update(notice);
    this.load();
  }

  async handleOk() {
    this.modalLoading = true;

    if (this.editMode) {
      await NoticeApi.update({
        ...this.datum,
      });
    } else {
      await NoticeApi.create({
        ...this.datum,
      });
    }

    this.load();
    this.resetDatum();
    this.modalLoading = false;
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
    this.resetDatum();
  }

  resetDatum() {
    this.datum = {
      title: "",
      content: "",
    };
    this.reset();
  }

  mounted() {
    this.load();
  }

  async load() {
    localStorage.removeItem("auth");
    const result = await NoticeApi.list(this.pagination);

    this.data = [...result.data];
    this.pagination.total = result.totalCount;
  }
}
